"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weekday = void 0;
const chrono_1 = require("../chrono");
const weekdayConstant = (weekday) => (context) => {
    context.pushWeekday(weekday);
};
const w_isWeekend = (context) => {
    const weekday = context.popWeekday();
    context.pushBoolean(weekday === chrono_1.Weekday.Saturday || weekday === chrono_1.Weekday.Sunday);
};
const w_toNumber = (context) => {
    context.pushNumber(context.popWeekday() + 1);
};
exports.weekday = [
    // Constants.
    ["sunday", weekdayConstant(chrono_1.Weekday.Sunday)],
    ["monday", weekdayConstant(chrono_1.Weekday.Monday)],
    ["tuesday", weekdayConstant(chrono_1.Weekday.Tuesday)],
    ["wednesday", weekdayConstant(chrono_1.Weekday.Wednesday)],
    ["thursday", weekdayConstant(chrono_1.Weekday.Thursday)],
    ["friday", weekdayConstant(chrono_1.Weekday.Friday)],
    ["saturday", weekdayConstant(chrono_1.Weekday.Saturday)],
    // Testing methods.
    ["weekday:weekend?", w_isWeekend],
    // Conversions.
    ["weekday:>number", w_toNumber],
];
